<template>
  <ProjectScaffold :loading="loadingBrief">
    <div class="flex">
      <div>
        <p class="title">Brief</p>
      </div>
      <div class="right-el">
        <ts-select
            placeholder="Template de brief"
            class="project-status-select"
            size="small"
            v-model="briefSelected"
            @change="handleValueChange"
        >
          <el-option
              v-for="status in selectableBrief"
              :key="status.id"
              :label="status.name"
              :value="status.id"
          ></el-option>
        </ts-select>&nbsp;&nbsp;
        <!-- <ts-button size="small" @click="handleOpenPickerButtonClick">Save as...</ts-button> -->
      </div>
    </div>

    <div v-if="briefSelected === 'b1'">
      <draggable v-model="b1" :list="b1" draggable=".form-section">
          <ts-form-section :title="item.title" class="form-section" v-for="item in b1" :key="item.id">
            <div class="actions-bloc">
              <ts-button type="primary" size="small" circle class="move-button" @click="moveElement(item.id)">
                <ts-icon icon="chevron-down" size="x-small" color="#6d7587"/>
              </ts-button>
              <ts-button type="primary" size="small" circle class="move-button">
                <ts-icon icon="hand" size="x-small" color="#6d7587"/>
              </ts-button>
              <ts-button type="primary" size="small" circle class="delete-button" @click="deleteElement(item.id, 'b1')">
                <ts-icon icon="trash" size="x-small" color="#6d7587"/>
              </ts-button>
            </div>
            <ts-form-item :label="item.label" class="form-item">
              <ts-input
                  :rows="6"
                  type="textarea"
                  v-model="formData[item.id]"
                  :placeholder="item.placeholder"
                  :disabled="loading"
              ></ts-input>
            </ts-form-item>
          </ts-form-section>
      </draggable>
    </div>

    <div v-if="briefSelected === 'b2'">
      <draggable v-model="b1" :list="b2" draggable=".form-section">
        <ts-form-section :title="item.title" class="form-section" v-for="item in b2" :key="item.id">
          <div class="actions-bloc">
            <ts-button type="primary" size="small" circle class="move-button" @click="moveElement(item.id)">
              <ts-icon icon="chevron-down" size="x-small" color="#6d7587"/>
            </ts-button>
            <ts-button type="primary" size="small" circle class="move-button">
              <ts-icon icon="hand" size="x-small" color="#6d7587"/>
            </ts-button>
            <ts-button type="primary" size="small" circle class="delete-button" @click="deleteElement(item.id, 'b2')">
              <ts-icon icon="trash" size="x-small" color="#6d7587"/>
            </ts-button>
          </div>
          <ts-form-item :label="item.label" class="form-item">
            <ts-input
                :rows="6"
                type="textarea"
                v-model="formData[item.id]"
                :placeholder="item.placeholder"
                :disabled="loading"
            ></ts-input>
          </ts-form-item>
        </ts-form-section>
      </draggable>
    </div>

    <div class="fixed right-0 bottom-10">
      <ts-button :loading="loading" :disabled="uploading" @click="handleSubmit">Save</ts-button>
    </div>
  </ProjectScaffold>
</template>

<style lang="scss" scoped>
.actions-bloc {
  text-align: right;
}

.delete-button {
  margin-left: 5px;
}

.flex {
  display: flex;
}

.right-0 {
  right: 3rem;
}

.right-el {
  margin: 0 0 0 auto;
}

.bottom-10 {
  bottom: 30px;
}

.fixed {
  position: absolute;
}

.flex-auto {
  flex: auto;
}

.pb-10 {
  padding-bottom: 3.25rem;
}

.mt-6 {
  margin-top: 1.5em;
}

.ml-4 {
  margin-left: 1em;
}

.title {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  color: #6d7587;

  margin-bottom: 30px;
}

.audience-subtitle {
  margin-top: 10px;
  font-weight: normal;
}

.form-section {
  margin-right: 160px;
  margin-bottom: 60px;
}

.form-item {
  margin: 12px 0;
}

.form-item-right-margin {
  margin-right: 30px;
}

.horizontal-items {
  display: flex;

  .delete-button {
    align-self: flex-end;
    margin-bottom: 25px;
    margin-left: 12px;
  }
}

.collapse {
  margin-bottom: 20px;
}

.item-group-title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.add-item-button {
  margin-top: 60px;
}

.add-section-button {
  margin-bottom: 80px;
}

.additional-section-actions {
  display: flex;
  justify-content: flex-end;

  > * {
    margin-left: 15px;
  }
}

.actions {
  width: 100%;
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
}
</style>

<script>
import {mapState, mapActions} from 'vuex';
import {required, requiredIf} from 'vuelidate/lib/validators';
import {omit, cloneDeep} from 'lodash';
import draggable from 'vuedraggable'

import {updateProjectBrief} from '@/api/workflow';
import {cache} from '@/support/cache';

import ProjectScaffold from '../ProjectScaffold.vue';
import EditAdditionalSection from './EditAdditionalSection.vue';
import SupportingFilesUploader from './SupportingFileUploader.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';

function withSupportingFilesAsIds(container) {
  const {supportingFiles, ...rest} = container;
  return {
    ...rest,
    supportingFileIds: supportingFiles.map(file => file.id)
  };
}

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold,
    EditAdditionalSection,
    SupportingFilesUploader,
    draggable
  },
  data() {
    return {
      formData: [],
      b1: [
        {
          id: 1,
          type: 'textarea',
          title: 'BRAND & PRODUCT',
          label: '',
          placeholder: 'A brief description of the brand. (if possible, please add a presentation about brand values/guidelines). If the campaign is about a particular product / topic, please also includes a description of it (USP, Key message...)',
        },
        {
          id: 2,
          type: 'textarea',
          title: 'TARGET AUDIENCES',
          label: '',
          placeholder: 'Please describe your core target audiences',
        },
        {
          id: 3,
          type: 'textarea',
          title: 'CONTEXT',
          label: '',
          placeholder: 'In which context does the communication occur ? Is there any specific event to promote ? Is there a global promotion theme ? Do you have a specific offer ? Do you launch a new product ? Please be as precise as possible.',
        },
        {
          id: 4,
          type: 'textarea',
          title: 'MEDIA OBJECTIVES',
          label: '',
          placeholder: 'Please describe your objectives & KPI, with priority order. (Online sales, app downloads,accounts creation, Branding, awareness…)'
        },
        {
          id: 5,
          type: 'textarea',
          title: 'PLACEMENTS',
          label: '',
          placeholder: 'If you already know which formats you need, please advise.',
        },
        {
          id: 6,
          type: 'textarea',
          title: 'CREATIVE OBJECTIVES',
          label: '',
          placeholder: 'What’s your message? What do you want to convey? Again, please be as specific aspossible ',
        },
        {
          id: 7,
          type: 'textarea',
          title: 'MANDATORIES & GUILDELINES',
          label: '',
          placeholder: 'If you have any mandatories/details you want to share, please do it here. ex: “I want to display these 3 products in the creative”, “We have to include these legal mentions in every content”.'
        },
        {
          id: 8,
          type: 'textarea',
          title: 'PAST CAMPAIGNS',
          label: '',
          placeholder: 'Please share examples of your past campaigns, with what you want to highlight in terms of what worked / didn’t work and best practices you’ve learned. Feel free to add content references or benchmarks you like.',
        },
        {
          id: 9,
          type: 'textarea',
          title: 'EXISTING ASSETS',
          label: '',
          placeholder: 'Please provide as many as possible existing creative &amp; material.' + 'Assets should include the following:\n' +
              '- Logos / Fonts / Branding guidelines\n' +
              '- Assets that we can optimize, including images and videos, without text or logo on it.\n' +
              '- For assets with text on it or multiple elements, please get layered PSD/Ai/AE files\n' +
              '- Audio files (layered is always better in this case too meaning voices separated from the\n' +
              'music)*'
        }
      ],
      b2: [
        {
          id: 10,
          type: 'textarea',
          title: 'BRAND & PRODUCT',
          label: '',
          placeholder: 'A brief description of the brand. (if possible, please include your brand guidelines).If the campaign is about a particular product / topic, please also include a brief product description (the USPs, key messages...)'
        },
        {
          id: 11,
          type: 'textarea',
          title: 'TARGET AUDIENCES',
          label: '',
          placeholder: 'Please describe your core target audience(s)'
        },
        {
          id: 12,
          type: 'textarea',
          title: 'CONTEXT',
          label: '',
          placeholder: 'Do you have a specific offer ? Are there any specific events you would like to promote? Are you launching a new product ? Please be as precise as possible.'
        },
        {
          id: 13,
          type: 'textarea',
          title: 'MEDIA OBJECTIVES',
          label: '',
          placeholder: 'Please describe your objectives & KPI, with priority order. (Online sales, app downloads, accounts creation, Branding, awareness…)'
        },
        {
          id: 14,
          type: 'textarea',
          title: 'PLACEMENTS',
          label: '',
          placeholder: 'If you already know which formats you need, please advise.'
        },
        {
          id: 15,
          type: 'textarea',
          title: 'CREATIVE OBJECTIVES',
          label: '',
          placeholder: 'What’s your message? What do you want to convey? Again, please be as specific as possible '
        },
        {
          id: 16,
          type: 'textarea',
          title: 'MANDATORIES & GUILDELINES',
          label: '',
          placeholder: 'If you have any mandatories/details you want to share, please do it here. ex: “I want to display these 3 products in the creative”, “We have to include these legal mentions in every content”.'
        },
        {
          id: 17,
          type: 'textarea',
          title: 'EXISTING ASSETS',
          label: '',
          placeholder: 'Please provide as many as possible existing creative &amp; material.\n' +
              'Assets should include the following:\n' +
              '- Logos / Fonts / Branding guidelines\n' +
              '- Assets that we can optimize, including images and videos, without text or logo on it.\n' +
              '- For assets with text on it or multiple elements, please get layered PSD/Ai/AE files\n' +
              '- Audio files (layered is always better in this case too meaning voices separated from themusic)*'
        },
        {
          id: 18,
          type: 'textarea',
          title: 'PAST CAMPAIGNS',
          label: '',
          placeholder: 'Please share examples of your past campaigns, with what you want to highlight in terms of\n' +
              'what worked / didn’t work and best practices you’ve learned.\n' +
              'Feel free to add content references or benchmarks you like.'
        },
      ],
      loading: false,
      isEditing: false,
      briefSelected: 'b1',
      selectableBrief: [
        {name: 'Social ads', id: 'b1'},
        {name: 'Social ads / Original content', id: 'b2'},
        {name: 'Snap ads/story ads', id: 'b3'},
        {name: 'Teads atelier', id: 'b4'},
        {name: 'TikTok Original ads', id: 'b5'},
        {name: 'Covid 19 specific brief', id: 'b6'},
        {name: 'NGO', id: 'b7'},
        {name: 'Amazon creative days', id: 'b8'},
        {name: 'Creative exploration', id: 'b9'},
        {name: 'Social ads (Annual Brief) ', id: 'b10'},
        {name: 'Music ', id: 'b11'},
        {name: 'Pinterest creative', id: 'b12'},
        {name: 'Filter/Brand effect', id: 'b13'},
        {name: 'Tik Tok activation', id: 'b14'}
      ],
      form: {
        topic: {
          description: '',
          supportingFiles: []
        },
        objectives: {
          primaryObjective: {
            type: ''
          },
          secondaryObjective: {
            type: ''
          },
          supportingFiles: []
        },
        audiences: [
          {
            description: '',
            problemSolved: '',
            previousResults: '',
            keyMessages: '',
            thingToRecall: '',
            proof: '',
            callToAction: '',
            supportingFiles: []
          }
        ],
        scope: {
          deliverables: '',
          languagesNeeded: '',
          supportingFiles: []
        },
        additionalSections: [],
        supportingFiles: [],
        specific:[]
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      currentProjectId: state => state.currentProjectId,
      objectives: state => state.objectives.items
    }),
    ...mapState('workflow/brief', {
      loadingBrief: state => state.brief.loading,
      brief: state => state.brief.value,
      briefError: state => state.brief.error
    }),
    myList: {
      get() {
        return this.$store.state.myList
      },
      set(value) {
        this.$store.commit('updateList', value)
      }
    },
    uploading() {
      return (
          this.form.topic.supportingFiles.filter(f => !f.createdAt).some(f => f.status && f.status !== 'success') ||
          this.form.audiences.some(audience =>
              audience.supportingFiles.filter(f => !f.createdAt).some(f => f.status && f.status !== 'success')
          ) ||
          this.form.scope.supportingFiles.filter(f => !f.createdAt).some(f => f.status && f.status !== 'success')
      );
    }
  },
  validations: {
    form: {
      topic: {
        description: {
          required
        }
      },
      objectives: {
        primaryObjective: {
          type: {
            required
          },
          value: {
            required: requiredIf(function () {
              return this.form.objectives.primaryObjective.type === 'other';
            })
          }
        },
        secondaryObjective: {
          type: {
            required
          },
          value: {
            required: requiredIf(function () {
              return this.form.objectives.secondaryObjective.type === 'other';
            })
          }
        }
      },
      audiences: {
        $each: {
          open: {},
          description: {
            required
          },
          problemSolved: {
            required
          },
          previousResults: {
            required
          },
          keyMessages: {
            required
          },
          thingToRecall: {
            required
          },
          proof: {
            required
          },
          callToAction: {
            required
          }
        }
      },
      scope: {
        deliverables: {
          required
        },
        languagesNeeded: {
          required
        }
      },
      additionalSections: {
        $each: {
          fields: {}
        }
      }
    }
  },
  methods: {
    ...mapActions('workflow/brief', ['fetchCurrentProjectBrief', 'refreshCurrentProjectBrief']),
    handleAddAudienceClick() {
      this.form.audiences.map(audience => (audience.open = false));
      this.form.audiences.push({
        open: true,
        description: '',
        problemSolved: '',
        previousResults: '',
        keyMessages: '',
        thingToRecall: '',
        proof: '',
        callToAction: '',
        supportingFiles: []
      });
    },
    deleteElement(id, source) {
      const key = this[source].findIndex(data => data.id === id);
      this[source].splice(key, 1);
    },
    handleAdditionalSectionEditClick(sectionIndex) {
      this.form.additionalSections.splice(sectionIndex, 1, {
        ...this.form.additionalSections[sectionIndex],
        updating: true
      });
    },
    handleAdditionalSectionRemoveClick(sectionIndex) {
      this.form.additionalSections = this.form.additionalSections.filter((_, i) => i !== sectionIndex);
    },
    handleAdditionalSectionChange(sectionIndex, value) {
      this.form.additionalSections.splice(sectionIndex, 1, {
        ...value,
        updating: false
      });
    },
    moveElement(id) {
      const index = this[this.briefSelected].findIndex(data => data.id === id);
      const element = this[this.briefSelected].splice(index, 1)[0];
      this[this.briefSelected].splice(index + 1, 0, element);
    },
    handleAddAdditionalSectionClick() {
      this.form.additionalSections = [
        ...this.form.additionalSections,
        {
          name: '',
          fields: [
            {
              name: '',
              value: ''
            }
          ],
          updating: true
        }
      ];
    },
    handleValueChange() {
      if (confirm('You will loose current data ?')) {
        return;
      }
    },
    handleOpenPickerButtonClick() {
      console.log('save as');
    },
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid || this.isProjectManager || this.isCreator) {
        this.loading = true;
        this.serialize();
        let dataBrief = []
        for(let data of this[this.briefSelected]) {
          data.value = this.formData[data.id];
          dataBrief.push(data);
        }
        updateProjectBrief({
          projectId: this.currentProjectId,
          brief: withSupportingFilesAsIds({
            ...this.form,
            topic: withSupportingFilesAsIds(this.form.topic),
            objectives: withSupportingFilesAsIds(this.form.objectives),
            audiences: this.form.audiences.map(withSupportingFilesAsIds),
            scope: withSupportingFilesAsIds(this.form.scope),
            specific: dataBrief,
            template: this.briefSelected,
            additionalSections: this.form.additionalSections.map(additionalSection =>
                omit(additionalSection, ['updating'])
            )
          })
        })
            .then(brief => {
              this.loading = false;
              this.refreshCurrentProjectBrief(brief);
              this.clearDraft();
              this.isEditing = false;
              this.$router.push({name: 'project-brief'});
            })
            .catch(err => {
              console.error('Server error when updating project brief', err);
              this.showError('Error when updating project brief');
              this.loading = false;
            });
        return;
      }

      for (const [, audience] of Object.entries(this.$v.form.audiences.$each.$iter)) {
        if (audience.$invalid) {
          audience.open.$model = true;
        }
      }
      for (const sectionName of Object.keys(this.$v.form)) {
        if (
            this.$v.form[sectionName] &&
            this.$v.form[sectionName].$invalid &&
            this.$refs[sectionName] &&
            this.$refs[sectionName].$el &&
            this.$refs[sectionName].$el.scrollIntoView
        ) {
          this.$refs[sectionName].$el.scrollIntoView({behavior: 'smooth'});
          break;
        }
      }

      this.showError('You must fill in all required fields');
    },
    handleDeleteAudience(target) {
      this.form.audiences = this.form.audiences.filter((item, index) => index != target);
    },
    handleDeleteSecondaryObjective() {
      this.form.objectives.secondaryObjective = {
        type: ''
      };
    },
    serialize() {
      this.form.audiences.map(audience => delete audience.open);
    },
    unserialize(brief) {
      brief.audiences.map((audience, index) => (audience.open = index === 0));
      return brief;
    },
    generateBrief(data) {
      let returnData = '';
      switch (data) {
        case 'textarea':
          returnData = '';
          break;
      }

      return returnData;
    },
    getDraft(defaultValu) {
      const brief = cache(`brief.${defaultValu.id}`);

      return brief || defaultValu;
    },
    clearDraft() {
      cache().forget(`brief.${this.brief.id}`);
    },
    confirmExit(event = null) {
      return !this.isDirty() || this.shouldExitWithoutSaving(event);
    },
    shouldExitWithoutSaving(event = null) {
      const message = "WARNING - You haven't saved your brief. The information will be lost";

      if (event) {
        event.returnValue = message;
      }

      return event ? message : confirm(message);
    },
    saveDraft() {
      if (!this.isDirty()) return;

      cache(`brief.${this.brief.id}`, cloneDeep(this.form));
    },
    isDirty() {
      if (!this.isEditing) return false;

      let oldValu = JSON.stringify(this.unserialize(this.brief));
      let newValue = JSON.stringify(this.unserialize(this.form));

      if (oldValu !== newValue) {
        return true;
      }

      return false;
    },
    initForm(brief) {
      return this.unserialize(cloneDeep(brief));
    }
  },
  async mounted() {
    await this.fetchCurrentProjectBrief();
    if (this.brief) {
      this.form = this.initForm(this.brief);
      if (this.brief.template) {
        this[this.brief.template] = this.brief.specific;
        for (const value of this.brief.specific) {
          this.formData[value.id] = value.value;
        }
        this.briefSelected = this.brief.template;
      }
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.confirmExit);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.confirmExit);
  },
  beforeRouteLeave(to, from, next) {
    !this.confirmExit() || next();
  },
  watch: {
    brief(value) {
      if (value) {
        this.form = this.initForm(value);
      }
    },
    form: {
      handler(val) {
        if (this.isEditing) return;

        this.isEditing = true;
      },
      deep: true
    },
    briefError(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
